<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <sidebar
      :store-module-name="STORE_MODULE_NAME"
      :is-sidebar-active.sync="isSidebarActive"
      :show.sync="show"
      :data="sidebarData"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="pageSize"
              />
              <label for="">{{ $t('entries') }}</label>
              <span class="ml-1 text-muted">{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t("of") }} {{ queriedItems }}</span>
              <v-select
                v-model="statusCredits"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="OptionStatusCredit"
                :reduce="(OptionStatusCredit) => OptionStatusCredit.value"
                :clearable="false"
                class="per-page-selector v-select-custom"
              />
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="b-col-custom"
            >

              <div class="d-flex align-items-center justify-content-end">
                <b-form-group
                  :label="$t('Start Date')"
                  label-for="start-date"
                  class="mb-75 mr-75"
                >
                  <flat-pickr
                    id="startDate"
                    v-model="startDate"
                    class="form-control"
                    :config="configs"
                    @input="onChangeDate()"
                  />
                </b-form-group>
                <b-form-group
                  :label="$t('End Date')"
                  label-for="end-date"
                  class="mb-75 mr-75"
                >
                  <flat-pickr
                    id="endDate"
                    v-model="endDate"
                    class="form-control"
                    :config="configs"
                    @input="onChangeDate()"
                  />
                </b-form-group>

                <!-- <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search')+'...'"
                  @input="typing($event)"
                /> -->
                <!-- <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="d-flex"
                  @click="sidebarAddNew()"
                >
                  <feather-icon
                    icon="PlusIcon"
                  />
                </b-button> -->
              <!-- <b-form-file
                @change="importFileJson"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".json"
              /> -->
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          striped
          responsive
          class="position-relative"
          :items="respData"
          :fields="tableColumns"
          primary-key="_id"
          show-empty
          :empty-text="$t('No matching records found')"
          style="height: 60vh;"
        >
          <template #cell(name)="data">
            <p
              class="align-text-bottom line-height-1"
            >{{ data.item.userInfoId.firstName }} {{ data.item.userInfoId.firstName }}</p>
          </template>
          <template #cell(statusCredits)="data">
            <b-badge
              pill
              :variant="colorStatusCredit(data.item.statusCredits)"
            >
              {{ firstStringUpper(data.item.statusCredits) }}
            </b-badge>
          </template>
          <template #cell(author)="data">
            <p
              class="align-text-bottom line-height-1"
            >{{ data.item.author !== null && data.item.author ? $t('Admin') : $t('Member') }}</p>
          </template>
          <template #cell(created)="data">
            <p
              class="align-text-bottom line-height-1"
            >{{ data.item.created | formatDateTimeNoSec }}</p>
          </template>
          <!-- Column: Action -->
          <template #cell(action)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="sidebarEdit(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t('Edit') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteData( data.item._id )">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t("of") }} {{ queriedItems }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="queriedItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="nextPage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
  BImg,
  BBadge,
  BAvatar,
  BFormInput, BButton,
  BTable, BPagination, BDropdown, BOverlay,
  BFormCheckbox,
  BDropdownItem,
  BFormFile,
  VBHover,
  BFormGroup,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/eCommerce/point'
import debounce from 'debounce'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th.js'
import moment from 'moment'
import Sidebar from './DataSidebar.vue'

const STORE_MODULE_NAME = 'point'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    BBadge,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    // eslint-disable-next-line vue/no-unused-components
    BFormCheckbox,
    BOverlay,
    BFormFile,

    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    Sidebar,
    BFormGroup,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
    'b-hover': VBHover,
  },
  data() {
    return {
      avatarText,
      image: '',
      showImage: false,
      currentPage: 1,
      searchQuery: '',
      type: '',
      statusCredits: 'all',
      perPage: localStorage.getItem('itemsPerPage') ? localStorage.getItem('itemsPerPage') : 50,
      isSidebarActive: false,
      sidebarData: {},
      startDate: moment().format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      configs: {
        enableTime: false,
        dateFormat: 'd-m-Y',
        locale: Thai,
      },
      show: false,
      perPageOptions,
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'amount', label: this.$t('Amount'), sortable: false },
        { key: 'name', label: this.$t('Name'), sortable: false },
        { key: 'statusCredits', label: this.$t('Status Credit'), sortable: false },
        { key: 'author', label: this.$t('Action By'), sortable: false },
        { key: 'created', label: this.$t('Created'), sortable: false },
        // { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    OptionStatusCredit() {
      return [
        { name: this.$t('All'), value: 'all' },
        { name: this.$t('Get credits'), value: 'get_credits' },
        { name: this.$t('Use credits'), value: 'use_credits' },
      ]
    },
    OptionStatusPayment() {
      return [
        { name: this.$t('All'), value: 'all' },
        { name: this.$t('Create'), value: 'create' },
        { name: this.$t('Pending'), value: 'pending' },
        { name: this.$t('Success'), value: 'success' },
        { name: this.$t('Cancel'), value: 'cancel' },
        { name: this.$t('Delete'), value: 'delete' },
        { name: this.$t('Error'), value: 'error' },
      ]
    },
    OptionMethod() {
      return [
        { name: this.$t('All'), value: 'all' },
        { name: this.$t('Income'), value: 'income' },
        { name: this.$t('Expenses'), value: 'expenses' },
        { name: this.$t('Deposit'), value: 'deposit' },
        { name: this.$t('Withdraw'), value: 'withdraw' },
        { name: this.$t('Refund'), value: 'refund' },
        { name: this.$t('Bonus'), value: 'bonus' },
        { name: this.$t('Pay'), value: 'pay' },
        { name: this.$t('Error'), value: 'error' },
        { name: this.$t('Cancel'), value: 'cancel' },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null ? store.state[STORE_MODULE_NAME].respData.data : []
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null ? store.state[STORE_MODULE_NAME].respData.max : 0
    },
    // eslint-disable-next-line vue/return-in-computed-property
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.show = false
      const type = to.fullPath.split('/')
      this.type = type[type.length - 1]
      this.get()
    },
    // eslint-disable-next-line no-unused-vars
    stateArea(newCount, oldCount) {
      this.get()
    },
    // eslint-disable-next-line no-unused-vars
    statusCredits(newData, oldData) {
      if (newData) {
        // eslint-disable-next-line no-unused-vars
        this.get()
      }
    },
    // eslint-disable-next-line no-unused-vars
    statusPayment(newData, oldData) {
      if (newData) {
        // eslint-disable-next-line no-unused-vars
        this.get()
      }
    },
    // eslint-disable-next-line no-unused-vars
    method(newData, oldData) {
      if (newData) {
        // eslint-disable-next-line no-unused-vars
        this.get()
      }
    },
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    const type = this.$route.path.split('/')
    this.type = type[type.length - 1]
    this.get()
    this.typing = debounce(this.typing, 500)
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
  },
  setup() {
    return { STORE_MODULE_NAME }
  },
  methods: {
    get() {
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        type: this.type,
        statusCredits: this.statusCredits,
        statusPayment: this.statusPayment,
        method: this.method,
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    onChangeDate() {
      console.log(this.startDate)
      console.log(this.endDate)
      this.get()
    },
    colorStatusCredit(value) {
      if (value === 'get_credits') {
        return 'success'
      } if (value === 'use_credits') {
        return 'warning'
      } if (value === 'cancel_credits') {
        return 'danger'
      }
      return 'dark'
    },
    firstStringUpper(value) {
      const text = value.substr(0, 1)
      const word = value.slice(1).replace('_', ' ')
      return this.$t(text.toUpperCase() + word)
    },
    switchChange(name, status, id) {
      console.log(name, status)
      const obj = {
        id,
        name,
        status,
      }
      store
        .dispatch(`${STORE_MODULE_NAME}/switchChange`, obj)
        .then(result => {
          console.log('fetch Success : ', result)
        })
        .catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        })
    },
    showFromCurrentLanguage(data) {
      const indexLang = data.findIndex(e => e.lang === this.$i18n.locale)
      if (indexLang > -1) {
        return data[indexLang].value
      }
      return ''
    },
    typing(value) {
      console.log(value)
      this.searchQuery = value
      this.get()
    },
    sidebarAddNew() {
      this.sidebarData = {}
      this.isSidebarActive = true
    },
    sidebarEdit(item) {
      this.sidebarData = item
      this.isSidebarActive = true
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/delete`, id)
              .then(result => {
                this.show = false
                console.log('fetch Success : ', result)
              }).catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      this.currentPage = 1
      this.get()
    },
    nextPage(page) {
      this.currentPage = page
      this.get()
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.b-col-custom {
  margin-top: 0.5rem;
}
.btn-upload {

  position: relative;
  width: 100px;
  // height: 200px;
}
.image-upload {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 99;
}
</style>
